import QuotationError from './QuotationError';
class QuotationInvalidPropertyID extends QuotationError {
    propertyId;
    constructor(propertyId, options) {
        super('The crowdfunding property id is not a uuid', options);
        this.propertyId = propertyId;
    }
}
export default QuotationInvalidPropertyID;
